import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { FaUserNurse } from "react-icons/fa";
import CommanSpinner from "../components/CommanSpinner";

const PatientDialog = ({
  createPatient,
  createAttachPatientPopup,
  closePopup,
  selectedProviderValue,
  currentPage,
  moveFaxToTrash,
  setMoveFaxToTrash,
  moveChildFaxToTrash,
  setMoveChildFaxToTrash,
  isLastChild,
  createPatientAndAttach,
  loader,
}) => {
  return (
    <>
      <Dialog
        open={createAttachPatientPopup}
        onClose={closePopup}
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={closePopup}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle sx={{ textAlign: "left", pt: 4 }}>
            {/* <Typography variant="h6" fontWeight="bold"> */}
            Create and Attach to Patient
            {/* </Typography> */}
          </DialogTitle>

          <DialogContent>
            If you continue, you will create a new patient and then attach the
            document to that patient.
            <Box sx={{ mt: 3 }}>
              {currentPage === "parent" ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveFaxToTrash}
                      onChange={() => setMoveFaxToTrash(!moveFaxToTrash)}
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label="Remove fax from inbox"
                />
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveChildFaxToTrash}
                      onChange={() =>
                        setMoveChildFaxToTrash(!moveChildFaxToTrash)
                      }
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label={
                    isLastChild
                      ? "Move parent fax to trash as well"
                      : "Move child fax to trash"
                  }
                />
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 3, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={closePopup}
              sx={{
                color: "#00AB4E",
                borderColor: "#00AB4E",
                "&:hover": {
                  borderColor: "#008C40",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => createPatientAndAttach("create")}
              sx={{
                backgroundColor: "#00AB4E",
                "&:hover": {
                  backgroundColor: "#008C40",
                },
              }}
            >
              CREATE & ATTACH
            </Button>
          </DialogActions>
        </Box>

        {loader === "create&AttPatientLoader" && (
          <CommanSpinner spinner={loader} text="" />
        )}
      </Dialog>
    </>
  );
};

export default PatientDialog;
